import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';

import { ToastService } from '../../services';
import { ToastType } from '../../common/enum/toast.enum';

interface ShowedToast {
  id: string;
  msg: string;
  type: ToastType;
  deleteProcess?: boolean;
}

@Component({
  selector: 'app-toast',
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
})
export class ToastComponent implements OnInit, OnDestroy {
  private readonly toastService = inject(ToastService);

  private destroy$: Subject<boolean> = new Subject<boolean>();

  private timeOutMap = new Map<string, any>();

  private timeOutRemoveProcessMap = new Map<string, any>();

  public toasts: ShowedToast[] = [];

  public TOAST_TYPE = ToastType;

  public TOAST_ICON = {
    [ToastType.ERROR]: 'error',
    [ToastType.SUCCESS]: 'check_circle',
  };

  public ngOnInit(): void {
    this.toastService
      .onToast()
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ msg, type }) => {
        this.addToast(msg, type);
      });
  }

  public ngOnDestroy(): void {
    this.timeOutMap.forEach((timeout) => {
      clearTimeout(timeout);
    });

    this.timeOutRemoveProcessMap.forEach((timeout) => {
      clearTimeout(timeout);
    });

    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private addToast(msg: string, type: ToastType): void {
    const id = Date.now().toString();

    this.toasts.push({
      id,
      msg,
      type,
    });

    const timeOut = setTimeout(() => {
      this.removeToastById(id);
    }, 5000);

    this.timeOutMap.set(id, timeOut);
  }

  public removeToastById(id: string): void {
    this.toasts.forEach((toast) => {
      if (toast.id === id) {
        toast.deleteProcess = true;
      }
    });

    this.timeOutMap.delete(id);

    const timeout = setTimeout(() => {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
      this.timeOutRemoveProcessMap.delete(id);
    }, 450);

    this.timeOutRemoveProcessMap.set(id, timeout);
  }

  public trackById(index: number, toast: ShowedToast): string {
    return toast.id;
  }
}
